if (!customElements.get('subscription-cart-handler')) {
	class SubscriptionCartHandler extends HTMLElement {
		constructor() {
			super();
			this.cartDrawer = document.getElementById('Cart-Drawer');

			if (!this.cartDrawer) return;

			this.cartDrawer.addEventListener('click', this.handleClick.bind(this), true);
			document.addEventListener('click', this.handleModalClick.bind(this));
		}

		handleClick(e) {
			const target = e.target.closest('.remove__subscription');

			if (!target) return;

			e.preventDefault();
			e.stopPropagation();

			const subscriptionNumber = target.getAttribute('data-subscription-number');

			if (!subscriptionNumber) {
				this.removeSingleItem(target);
				return;
			}

			const removeAll = target.getAttribute('data-remove-all') === 'true';
			const startOver = target.getAttribute('data-start-over') === 'true';

			if (removeAll) {
				this.removeSubscriptionBundle(subscriptionNumber, startOver);
				return;
			}

			this.showBundleWarningModal(subscriptionNumber);
		}

		handleModalClick(e) {
			const target = e.target.closest('.subscripton-warning-div [data-action]');

			if (!target) return;

			e.preventDefault();

			const action = target.getAttribute('data-action');
			const subscriptionNumber = target.getAttribute('data-subscription-number');

			if (action === 'dismiss') {
				this.dismissModal();
				return;
			}

			if (action === 'remove-all' && subscriptionNumber) {
				this.removeSubscriptionBundle(subscriptionNumber, false);
			}

			if (action === 'start-over' && subscriptionNumber) {
				this.removeSubscriptionBundle(subscriptionNumber, true);
			}
		}

		async getCartData() {
			const response = await fetch('/cart.js');

			return response.json();
		}

		async removeItemsByKeys(keys) {
			const updates = {};

			keys.forEach((key) => {
				updates[key] = 0;
			});

			const response = await fetch('/cart/update.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					updates,
					sections: 'cart-drawer,cart-bubble',
					sections_url: window.location.pathname,
				}),
			});

			return response.text();
		}

		async refreshCartDrawer(responseText) {
			if (window.CartDrawer && responseText) {
				window.CartDrawer.updateCartUI(responseText);
			}
		}

		async removeSingleItem(target) {
			const lineKey = target.getAttribute('data-key');

			if (!lineKey) return;

			const responseText = await this.removeItemsByKeys([lineKey]);

			if (window.location.pathname === '/cart') {
				window.location.reload();
			} else {
				await this.refreshCartDrawer(responseText);
				if (typeof window.getCartData === 'function') {
					window.getCartData();
				}
			}
		}

		async removeSubscriptionBundle(subscriptionNumber, redirectToApp) {
			const cartData = await this.getCartData();

			const bundleItems = cartData.items.filter(
				(item) => item.properties && parseInt(item.properties['Ref Code']) === parseInt(subscriptionNumber)
			);

			if (bundleItems.length === 0) return;

			const keys = bundleItems.map((item) => item.key);
			const responseText = await this.removeItemsByKeys(keys);

			this.dismissModal();

			if (redirectToApp) {
				window.location.href = '/pages/subscriptions/details';
				return;
			}

			if (window.location.pathname === '/cart') {
				window.location.reload();
			} else {
				await this.refreshCartDrawer(responseText);
				if (typeof window.getCartData === 'function') {
					window.getCartData();
				}
			}
		}

		showBundleWarningModal(subscriptionNumber) {
			if (!window.store?.LoadingModal) return;

			const warningDiv = document.createElement('div');

			warningDiv.classList.add('subscripton-warning-div');
			warningDiv.innerHTML = `
				<div class="subscripton-warning-div__inner">
					<h4 class="h4">By deleting this product you will cancel your subscription</h4>
					<h4 class="h5">What would you like to do next?</h4>
					<div class="flex-container flex-dir-row flex-wrap align-center-middle subscripton-warning-div__inner-buttons">
						<a class="button button--white button--gray-view" data-action="dismiss">Cancel</a>
						<a class="button button--border-green button--white" data-action="remove-all" data-subscription-number="${subscriptionNumber}">Remove All</a>
						<a class="button button--border-green button--white" data-action="start-over" data-subscription-number="${subscriptionNumber}">Start Over</a>
						<a class="button button--gradient-green" href="/checkout" role="button" title="Checkout"><span>Checkout</span></a>
					</div>
				</div>`;

			window.store.LoadingModal.addContent(warningDiv);
			window.store.LoadingModal.addClosingListener();
			window.store.LoadingModal.openModal();
		}

		dismissModal() {
			if (!window.store?.LoadingModal) return;

			window.store.LoadingModal.removeContent();
			window.store.LoadingModal.closeModal();
		}
	}

	customElements.define('subscription-cart-handler', SubscriptionCartHandler);
}
